import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { getGalleryContent } from "./selectors";
import { CareTypeIcon, HeartHandIcon, RulerIcon } from "../../lib/icons";
import { Show } from "../../lib/utils";
import type { RichModule } from "../../lib/types";

type Props = {
  galleryModule: RichModule,
};

/**
 * Information about the currently selected floor.
 */
export const FloorInfo = ({ galleryModule }: Props) => {
  const galleryContent = useSelector((state) => getGalleryContent(state, galleryModule));

  const activeFloor = galleryModule.activeFloor;
  const floor = galleryContent[activeFloor];
  if (!floor) {
    return null;
  }
  return (
    <FloorInfoWrapper>
      <FloorTitle>{floor.name}</FloorTitle>
      <table>
        {/* Fuck you, Andrew */}
        <tbody>
          <Show when={floor.room_size}>
            <FloorplanAttribute
              icon={<CareTypeIcon />}
              content={floor.room_size + (floor.num_baths ? `/ ${floor.num_baths} Bath(s)` : "")}
              fieldName="Room Size"
            />
          </Show>

          <Show when={floor.sq_feet}>
            <FloorplanAttribute icon={<RulerIcon />} content={floor.sq_feet} fieldName="Square feet" />
          </Show>

          <Show when={floor.care_types?.length > 0}>
            <FloorplanAttribute
              icon={<HeartHandIcon />}
              content={
                <>
                  {floor.care_types?.map((value, index) => {
                    return <CareTypeSupport key={index}>{value}</CareTypeSupport>;
                  })}
                </>
              }
              fieldName="Care Types Supported"
            />
          </Show>
        </tbody>
      </table>
    </FloorInfoWrapper>
  );
};

/**
 * Floor info wrapper.
 */
const FloorInfoWrapper = styled.div`
  color: ${(props) => props.theme.textColor || "green"};
  white-space: pre-line;
`;

/**
 * Floor Attribute.
 */
export const FloorplanAttribute = (props) => {
  const { content, fieldName, icon } = props;
  return (
    <tr>
      <td style={{ verticalAlign: "text-top" }}>
        <FloorPlanLineIcon>{icon}</FloorPlanLineIcon>
      </td>
      <td>
        <FloorPlanLineText>
          <TopText>{fieldName}</TopText>
          <BottomText>{content}</BottomText>
        </FloorPlanLineText>
      </td>
    </tr>
  );
};

const FloorTitle = styled.div`
  height: 60px;
  left: calc(50% - 139px / 2 - 46.5px);
  top: calc(50% - 60px / 2 - 322.5px);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 60px;
`;

const FloorPlanLineIcon = styled.div`
  width: 54px;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 22px;
  display: inline-block;
  margin-right: 15px;
`;

const FloorPlanLineText = styled.div`
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
`;

const TopText = styled.div`
  font-size: 10px;
  margin-bottom: 14px;
`;

const BottomText = styled.div`
  font-size: 14px;
  color: rgba(20, 18, 51, 0.6);
`;

const CareTypeSupport = styled.div`
  left: 24.42%;
  right: 41.92%;
  top: 41.25%;
  bottom: 54.6%;
  border: 2px solid #efeff2;
  border-radius: 23.5px;
  font-size: 11px;
  text-align: center;
  margin: 3px 0 3px 0;
  padding: 0 10px 0 10px;
  color: rgba(20, 18, 51, 0.6);
`;
